import { useEffect } from "react";
import { type Department, useAuth } from "../contexts/AuthProvider";
import { useAnalytics } from "../contexts/analytics/hooks";
import { useChosenDepartment } from "../contexts/ChosenDepartment";

/**
 * A department the user can open, by id — for pages that can show a department other than the chosen one, like
 * Management Center in the ops backoffice drill-down. The chosen department when it matches (the copy settings edits
 * update), otherwise the user's own department list. Undefined, and tracked, when that list lacks it.
 */
export const useDepartmentById = (departmentId: string): Department | undefined => {
	const { userInfo } = useAuth();
	const { chosenDepartment } = useChosenDepartment();
	const { trackError } = useAnalytics();
	const department = departmentId === chosenDepartment.department_id ? chosenDepartment : userInfo.departments.find((d) => d.department_id === departmentId);

	useEffect(() => {
		if (!department) trackError("department_not_found", { department_id: departmentId });
	}, [department, departmentId, trackError]);

	return department;
};
